/**
 * Pages
 */

export * from './pages/UpdateJobDetail/UpdateJobDetail';
